interface Props {
	iconColor?: string;
	width?: string;
	height?: string;
}
const SingleArrowNext = ({ iconColor = '#868E96', width = '24', height = '24' }: Props) => (
	<svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M9 5L15.1515 11.1515C15.6201 11.6201 15.6201 12.3799 15.1515 12.8485L9 19" stroke={iconColor} strokeWidth="1.5" strokeLinecap="round" />
	</svg>
);

export default SingleArrowNext;
